import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import Search from '../Utilities/Search'
import { RecieveSalariesVM } from '../../Structure/ViewModels/Marketer/RecieveSalariesVM'
import { SalaryDetails } from '../../Structure/Models/Marketer'
import { Globals } from '../../Structure/Globals/GlobalObs'
import { Router } from '../../Structure/Handlers/Router'
import MarketerDetails from '../Marketer/MarketerDetails'

const RecieveSalaries = () => {
    const [vm , setVm] = useState<{viewModel:RecieveSalariesVM}>({viewModel:new RecieveSalariesVM()})
    const control = vm.viewModel
    useEffect(()=>{
        control.subscribeUpdate(setVm)
        control.getData()
    },[])

  return (
    <Container>
    <Row className=' justify-content-center py-5'>
      <Col lg={8}  className='d-flex'>
        <div className='d-flex w-100 justify-content-center'>
          <Search hasNoSelect/>
        </div>
      </Col>
    </Row>
    {
        control.Show(
    <div className='py-5'>
        {
            control.List.map((item , index)=>{
                const Item = ()=>{
                    const [avail , setAvail] = useState(true)
                    return (
                    <div className='p-3' style={{display:avail?'block':'none'}}>
                        <div className='d-flex flex-wrap justify-content-between p-3 '>
                            <Row className='d-flex flex-wrap justify-content-between w-100'>
                                <Col md='9' className=' d-flex justify-content-between' onClick={()=>{
                                    if(Globals.auth.User?.permissions.some(a=>a.id=='7'))Router.OpenNormalPage(<MarketerDetails id={item.marketer_id}/>)
                                }}>
                                <h6  className='my-auto '>{item.marketer_name}</h6>
                                <h6  className='my-auto'>{item.confirmation_date}</h6>
                                <div className='d-flex justify-content-center'>
                                    <h6 className='my-auto'>مستحقات : </h6>
                                    <h6 className=' my-auto px-2'>
                                        {item.finalSalary}
                                    </h6>
                                </div>
                                <div className='d-flex justify-content-between py-3'>
                                    <h6 className='my-auto'> {item.mobile} </h6>
                                    <h6 className=' my-auto px-2'>
                                        {item.bank_account}
                                    </h6>
                                </div>
                                </Col>
                                <Col md='3'  className=' d-flex justify-content-center'>
                                    <div className='d-flex'>
                                        <div className='px-3 my-auto'>
                                            <button className='button-I btn-cl-I bg-success p-1 px-4 my-auto' onClick={()=>{control.acceptSalary(item.id); setAvail(false) }} >تسليم</button>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    )}
                    return(<Item key={index}/>)
                })
        }
    </div>)
    }
  </Container>
  )
}

export default RecieveSalaries
